import { toJsxRuntime as n } from "../../hast-util-to-jsx-runtime/lib/index.js";
function f(t) {
  const e = (
    /** @type {Processor} */
    this
  );
  e.compiler = o;
  function o(i, r) {
    return n(i, { filePath: r.path, ...t });
  }
}
export {
  f as default
};
//# sourceMappingURL=index.js.map
